export default "__VITE_ASSET__CiT$VuKK__"